/**
 * 快速加车侧边栏尺码表。
 * 只初始化 data-size-chart-context="quickview" 的表。
 * 商品页尺码表仍由模板里的自定义代码初始化。
 */
(function () {
  function mount(chart) {
    if (!(chart instanceof Element)) return;
    if (chart.getAttribute('data-size-chart-context') !== 'quickview') return;
    if (chart.dataset.chartMounted === 'true') return;
    if (!chart.id || !chart.getAttribute('data-size-data-id')) return;

    chart.dataset.chartMounted = 'true';


  const chartId = chart.id;
  const productId = chart.getAttribute('data-product-id') || '';
  const dataId = chart.getAttribute('data-size-data-id');

  if (!dataId) {
    return;
  }

  let dataAttempts = 0;

  function waitForData() {
    const dataElement =
      document.getElementById(dataId);

    if (!dataElement) {
      dataAttempts += 1;

      if (dataAttempts < 50) {
        window.setTimeout(
          waitForData,
          100
        );
      }

      return;
    }

    let sizeChartConfigs;

    try {
      sizeChartConfigs =
        JSON.parse(
          dataElement.textContent
        );
    } catch (error) {
      console.error(
        'Jovellee size data parse error:',
        error
      );
      return;
    }

    initializeChart(
      sizeChartConfigs
    );
  }

  function initializeChart(
    sizeChartConfigs
  ) {
    const chartType =
      chart.dataset.chartType ||
      'women-dress';

    const activeConfig =
      sizeChartConfigs[chartType] ||
      sizeChartConfigs['women-dress'];

    if (
      !activeConfig ||
      !Array.isArray(activeConfig.data)
    ) {
      return;
    }

    const sizeData =
      activeConfig.data;

    window.__jovelleeSizeChartCleanup =
      window.__jovelleeSizeChartCleanup ||
      {};

    if (
      typeof
      window.__jovelleeSizeChartCleanup[
        chartId
      ] ===
      'function'
    ) {
      window.__jovelleeSizeChartCleanup[
        chartId
      ]();
    }

    const controller =
      new AbortController();

    const signal =
      controller.signal;

    let pageObserver = null;
    let locateTimer = null;
    let observerTimer = null;
    let renderFrame = null;
    let lastRenderKey = '';

    const connectedProductForms =
      new WeakSet();

    window.__jovelleeSizeChartCleanup[
      chartId
    ] = function () {
      controller.abort();

      if (pageObserver) {
        pageObserver.disconnect();
      }

      if (locateTimer) {
        window.clearTimeout(
          locateTimer
        );
      }

      if (observerTimer) {
        window.clearTimeout(
          observerTimer
        );
      }

      if (renderFrame) {
        window.cancelAnimationFrame(
          renderFrame
        );
      }
    };

    const standardChart =
      chart.querySelector(
        '[data-standard-chart]'
      );

    const customMeasurements =
      chart.querySelector(
        '[data-custom-measurements]'
      );

    const customFieldsContainer =
      chart.querySelector(
        '[data-custom-fields]'
      );

    const tableHead =
      chart.querySelector(
        '[data-table-head]'
      );

    const tableBody =
      chart.querySelector(
        '[data-table-body]'
      );

    const unitButtons =
      chart.querySelectorAll(
        '[data-unit-button]'
      );

    const unitProperty =
      chart.querySelector(
        '[data-unit-property]'
      );

    const eventDate =
      chart.querySelector(
        '[data-event-date]'
      );

    function getPropertyInputs() {
      return chart.querySelectorAll(
        '[name^="properties["]'
      );
    }

    function getCustomInputs() {
      return chart.querySelectorAll(
        '[data-custom-input]'
      );
    }

    function getUnitSuffixes() {
      return chart.querySelectorAll(
        '[data-unit-suffix]'
      );
    }

    function buildTableHeader() {
      tableHead.innerHTML = '';

      const row =
        document.createElement('tr');

      const sizeHeading =
        document.createElement('th');

      sizeHeading.textContent =
        activeConfig.sizeLabel || 'Size';

      row.appendChild(
        sizeHeading
      );

      activeConfig.columns.forEach(
        function (column) {
          const heading =
            document.createElement(
              'th'
            );

          heading.textContent =
            column.label;

          row.appendChild(
            heading
          );
        }
      );

      tableHead.appendChild(row);
    }

    function buildCustomFields() {
      customFieldsContainer.innerHTML =
        '';

      activeConfig.customFields.forEach(
        function (field) {
          const label =
            document.createElement(
              'label'
            );

          label.className =
            'jovellee-size-chart__field';

          const hiddenLabel =
            document.createElement(
              'span'
            );

          hiddenLabel.className =
            'jovellee-size-chart__visually-hidden';

          hiddenLabel.textContent =
            field.label;

          const input =
            document.createElement(
              'input'
            );

          input.type = 'number';

          input.name =
            'properties[' +
            field.name +
            ']';

          input.placeholder =
            field.label;

          input.step = '0.01';
          input.min = '0';
          input.inputMode =
            'decimal';

          input.dataset.customInput =
            '';

          input.disabled = true;

          const suffix =
            document.createElement(
              'span'
            );

          suffix.dataset.unitSuffix =
            '';

          suffix.textContent = 'in';

          label.appendChild(
            hiddenLabel
          );

          label.appendChild(
            input
          );

          label.appendChild(
            suffix
          );

          customFieldsContainer.appendChild(
            label
          );
        }
      );
    }

    function normalizeText(value) {
      return String(value || '')
        .replace(/\s+/g, ' ')
        .trim();
    }

    /* 尺码表里的 US0、US16W 显示成 0、16W。 */
    function displaySizeLabel(value) {
      const match = String(value || '')
        .replace(/\s+/g, '')
        .match(/^US(\d+W?)$/i);

      if (!match) {
        return value || '';
      }

      return match[1].toUpperCase();
    }

    function sizeKey(value) {
      let raw =
        normalizeText(value)
          .toUpperCase();

      if (!raw) {
        return '';
      }

      const letterInLabel =
        raw.match(/\(([^)]+)\)/);

      if (letterInLabel) {
        raw = letterInLabel[1].trim();
      }

      raw = raw.split('/')[0].trim();

      if (
        /CUSTOM[\s_-]*SIZE/.test(raw) ||
        /MADE[\s_-]*TO[\s_-]*MEASURE/.test(raw) ||
        /CUSTOMIZED/.test(raw)
      ) {
        return 'CUSTOMSIZE';
      }

      if (
        chartType ===
        'women-dress'
      ) {
        const usMatch =
          raw.match(
            /US[\s_-]*(\d+W?)/
          );

        if (
          usMatch &&
          usMatch[1]
        ) {
          return (
            'US' +
            usMatch[1]
          );
        }

        const numberMatch =
          raw.match(
            /^(\d+W?)$/
          );

        if (
          numberMatch &&
          numberMatch[1]
        ) {
          return (
            'US' +
            numberMatch[1]
          );
        }
      }

      if (
        chartType ===
        'junior'
      ) {
        const juniorMatch =
          raw.match(
            /^(?:CHILD[\s_-]*|C[\s_-]*)?(\d{1,2})$/
          );

        if (
          juniorMatch &&
          juniorMatch[1]
        ) {
          return (
            'C' +
            juniorMatch[1]
          );
        }
      }

      let cleaned =
        raw.replace(
          /[^A-Z0-9]/g,
          ''
        );

      const alphaMap = {
        XXL: '2XL',
        XXXL: '3XL',
        XXXXL: '4XL',
        XXXXXL: '5XL',
        XXXXXXL: '6XL'
      };

      if (
        alphaMap[cleaned]
      ) {
        cleaned =
          alphaMap[cleaned];
      }

      return cleaned;
    }

    const knownSizeKeys =
      new Set(
        sizeData.map(
          function (row) {
            return sizeKey(
              row.size
            );
          }
        )
      );

    function isCustomSize(value) {
      return (
        sizeKey(value) ===
        'CUSTOMSIZE'
      );
    }

    function looksLikeSize(value) {
      const key =
        sizeKey(value);

      return (
        knownSizeKeys.has(key) ||
        key === 'CUSTOMSIZE'
      );
    }

    function getControlText(
      control
    ) {
      return normalizeText(
        control.value ||
        control.getAttribute(
          'data-value'
        ) ||
        control.getAttribute(
          'data-option-value'
        ) ||
        control.getAttribute(
          'aria-label'
        ) ||
        control.textContent
      );
    }

    function isVisible(element) {
      if (!element) {
        return false;
      }

      const style =
        window.getComputedStyle(
          element
        );

      return (
        style.display !==
          'none' &&
        style.visibility !==
          'hidden' &&
        element.getClientRects()
          .length > 0
      );
    }

    function getElementDepth(
      element
    ) {
      let depth = 0;
      let current = element;

      while (
        current &&
        current !== document.body
      ) {
        depth += 1;
        current =
          current.parentElement;
      }

      return depth;
    }

    function getGroupHeading(
      element
    ) {
      const attributes = [
        element.getAttribute(
          'data-option-name'
        ),
        element.getAttribute(
          'data-name'
        ),
        element.getAttribute(
          'name'
        ),
        element.getAttribute(
          'aria-label'
        )
      ]
        .filter(Boolean)
        .join(' ');

      let heading = null;

      try {
        heading =
          element.querySelector(
            ':scope > legend,' +
            ':scope > .form__label,' +
            ':scope > .product-form__label,' +
            ':scope > [class*="option-label"]'
          );
      } catch (error) {
        heading =
          element.querySelector(
            'legend,' +
            '.form__label,' +
            '.product-form__label'
          );
      }

      return normalizeText(
        attributes +
        ' ' +
        (
          heading
            ? heading.textContent
            : ''
        )
      );
    }

    function countSizeControls(
      element
    ) {
      const controls =
        element.querySelectorAll(
          'input[type="radio"],' +
          'select option,' +
          '[role="radio"],' +
          'button,' +
          'label'
        );

      const found =
        new Set();

      controls.forEach(
        function (control) {
          const value =
            getControlText(
              control
            );

          if (
            looksLikeSize(value)
          ) {
            found.add(
              sizeKey(value)
            );
          }
        }
      );

      return found.size;
    }

    function findSizeGroup() {
      const searchRoot =
        chart.closest(
          '.product__section,' +
          '.js-quickview-wrapper'
        ) || document;

      const candidates =
        searchRoot.querySelectorAll(
          'fieldset,' +
          '.product-form__input,' +
          '[data-option-name],' +
          '[data-option-index],' +
          '[role="radiogroup"]'
        );

      let bestElement = null;
      let bestScore =
        -Infinity;

      candidates.forEach(
        function (element) {
          if (
            chart.contains(
              element
            ) ||
            element.closest(
              'footer'
            )
          ) {
            return;
          }

          const heading =
            getGroupHeading(
              element
            );

          const headingMatches =
            /\bsize\b|尺码|尺寸/i.test(
              heading
            );

          const sizeCount =
            countSizeControls(
              element
            );

          if (
            !headingMatches &&
            sizeCount < 2
          ) {
            return;
          }

          let score = 0;

          if (
            headingMatches
          ) {
            score += 100;
          }

          score +=
            sizeCount * 10;

          if (
            element.tagName ===
            'FIELDSET'
          ) {
            score += 25;
          }

          if (
            element.closest(
              '.product__section,' +
              'product-info,' +
              'section[id*="MainProduct"],' +
              'main .product,' +
              '.product__info-container'
            )
          ) {
            score += 30;
          }

          if (
            element.closest(
              'main'
            )
          ) {
            score += 10;
          }

          if (
            isVisible(element)
          ) {
            score += 10;
          }

          score +=
            getElementDepth(
              element
            );

          const nestedFieldsets =
            element.querySelectorAll(
              'fieldset'
            ).length;

          if (
            nestedFieldsets > 1
          ) {
            score -=
              nestedFieldsets *
              25;
          }

          if (
            score >
            bestScore
          ) {
            bestScore = score;
            bestElement =
              element;
          }
        }
      );

      return bestElement;
    }

    function getVariantPickerTarget(
      sizeGroup
    ) {
      if (!sizeGroup) {
        return null;
      }

      // 尺码刷新会整段替换 .product__variants-swatches。
      // 填写框放在它后面，才不会被这次替换清掉。
      const quickviewSwatches =
        sizeGroup.closest(
          '.product__variants-swatches'
        );

      if (quickviewSwatches) {
        return quickviewSwatches;
      }

      const editorBlock =
        sizeGroup.closest(
          '[data-shopify-editor-block]'
        );

      if (
        editorBlock &&
        !editorBlock.closest(
          'footer'
        )
      ) {
        return editorBlock;
      }

      const explicitVariantPicker =
        sizeGroup.closest(
          'variant-selects,' +
          'variant-radios,' +
          'product-variant-picker,' +
          '[data-block-type="variant_picker"],' +
          '[data-product-variants],' +
          '.product-form__variants,' +
          '.product-variant-picker,' +
          '[class*="variant-picker"],' +
          '[class*="variant_picker"]'
        );

      if (
        explicitVariantPicker
      ) {
        return (
          explicitVariantPicker
        );
      }

      const productInput =
        sizeGroup.closest(
          '.product-form__input'
        );

      if (productInput) {
        return productInput;
      }

      if (
        sizeGroup.tagName ===
          'FIELDSET' &&
        sizeGroup.parentElement
      ) {
        return (
          sizeGroup.parentElement
        );
      }

      return sizeGroup;
    }

    function getProductRoot(
      sizeGroup
    ) {
      if (!sizeGroup) {
        return document;
      }

      return (
        sizeGroup.closest(
          '.product__section,' +
          'product-info,' +
          'section[id*="MainProduct"],' +
          '.product__info-container,' +
          '.product-info,' +
          'main .product,' +
          'main'
        ) ||
        document
      );
    }

    function findProductForm(
      sizeGroup
    ) {
      const productRoot =
        getProductRoot(
          sizeGroup
        );

      let productForm =
        sizeGroup.closest(
          'form[action*="/cart/add"]'
        );

      if (!productForm) {
        const addButton =
          productRoot.querySelector(
            'button[name="add"],' +
            'input[name="add"],' +
            '[data-add-to-cart]'
          );

        if (addButton) {
          productForm =
            addButton.form ||
            addButton.closest(
              'form[action*="/cart/add"]'
            );
        }
      }

      if (!productForm) {
        productForm =
          productRoot.querySelector(
            'form[action*="/cart/add"]'
          );
      }

      return productForm;
    }

    function connectPropertiesToForm(
      sizeGroup,
      forcedProductForm
    ) {
      const productForm =
        forcedProductForm ||
        findProductForm(
          sizeGroup
        );

      if (!productForm) {
        return null;
      }

      if (!productForm.id) {
        productForm.id =
          'jovellee-product-form-' +
          productId;
      }

      getPropertyInputs().forEach(
        function (input) {
          input.setAttribute(
            'form',
            productForm.id
          );
        }
      );

      if (
        !connectedProductForms.has(
          productForm
        )
      ) {
        productForm.addEventListener(
          'formdata',
          function (event) {
            getPropertyInputs().forEach(
              function (input) {
                const name =
                  input.name;

                const value =
                  String(
                    input.value ||
                    ''
                  ).trim();

                event.formData.delete(
                  name
                );

                if (
                  input.disabled ||
                  value === ''
                ) {
                  return;
                }

                event.formData.append(
                  name,
                  value
                );
              }
            );
          },
          {
            signal: signal
          }
        );

        connectedProductForms.add(
          productForm
        );
      }

      return productForm;
    }

    function ensureCorrectPosition() {
      const sizeGroup =
        findSizeGroup();

      if (!sizeGroup) {
        return null;
      }

      const target =
        getVariantPickerTarget(
          sizeGroup
        );

      if (!target) {
        return null;
      }

      if (
        target.nextElementSibling !==
        chart
      ) {
        target.insertAdjacentElement(
          'afterend',
          chart
        );
      }

      connectPropertiesToForm(
        sizeGroup
      );

      chart.dataset.ready =
        'true';

      return sizeGroup;
    }

    function getSelectedSize(
      sizeGroup
    ) {
      if (!sizeGroup) {
        return '';
      }

      const checkedInputs =
        sizeGroup.querySelectorAll(
          'input[type="radio"]:checked,' +
          'input[type="checkbox"]:checked'
        );

      for (
        const input
        of checkedInputs
      ) {
        const value =
          getControlText(
            input
          );

        if (
          looksLikeSize(value)
        ) {
          return sizeKey(
            value
          );
        }
      }

      const selectedOption =
        sizeGroup.querySelector(
          'select option:checked'
        );

      if (
        selectedOption
      ) {
        const optionText =
          normalizeText(
            selectedOption.textContent
          );

        if (
          looksLikeSize(
            optionText
          )
        ) {
          return sizeKey(
            optionText
          );
        }

        const optionValue =
          getControlText(
            selectedOption
          );

        if (
          looksLikeSize(
            optionValue
          )
        ) {
          return sizeKey(
            optionValue
          );
        }
      }

      const activeControls =
        sizeGroup.querySelectorAll(
          '[aria-checked="true"],' +
          '[aria-pressed="true"],' +
          '[aria-selected="true"],' +
          '.is-selected,' +
          '.selected,' +
          '.active'
        );

      for (
        const control
        of activeControls
      ) {
        const value =
          getControlText(
            control
          );

        if (
          looksLikeSize(value)
        ) {
          return sizeKey(
            value
          );
        }
      }

      const selectedValueElements =
        sizeGroup.querySelectorAll(
          '[data-selected-value],' +
          '.product-form__input__selected-value,' +
          '[class*="selected-value"],' +
          '[class*="selected_value"]'
        );

      for (
        const element
        of selectedValueElements
      ) {
        const value =
          normalizeText(
            element.getAttribute(
              'data-selected-value'
            ) ||
            element.textContent
          );

        if (
          looksLikeSize(value)
        ) {
          return sizeKey(
            value
          );
        }
      }

      const heading =
        sizeGroup.querySelector(
          'legend,' +
          '.form__label,' +
          '.product-form__label'
        );

      if (heading) {
        const match =
          normalizeText(
            heading.textContent
          ).match(
            /(?:size|尺码|尺寸)\s*[:：]\s*(.+)$/i
          );

        if (
          match &&
          match[1] &&
          looksLikeSize(
            match[1]
          )
        ) {
          return sizeKey(
            match[1]
          );
        }
      }

      return '';
    }

    function formatMeasurement(
      measurement,
      unit
    ) {
      if (!measurement) {
        return '—';
      }

      const value =
        measurement[unit];

      if (
        value === null ||
        value === undefined ||
        value === ''
      ) {
        return '—';
      }

      const number = Number(value);

      if (
        typeof value === 'number' ||
        (
          Number.isFinite(number) &&
          String(number) === String(value).trim()
        )
      ) {
        return String(number);
      }

      return String(value);
    }

    function formatColumnValue(
      row,
      column,
      unit
    ) {
      const value =
        row[column.key];

      if (
        column.type ===
        'plain'
      ) {
        if (
          value === null ||
          value === undefined ||
          value === ''
        ) {
          return '—';
        }

        return String(value);
      }

      return formatMeasurement(
        value,
        unit
      );
    }

    function getVisibleRows(
      selectedIndex
    ) {
      const rowsToShow = 3;

      if (
        selectedIndex < 0
      ) {
        return sizeData.slice(
          0,
          rowsToShow
        );
      }

      let startIndex =
        selectedIndex - 1;

      const maximumStart =
        Math.max(
          sizeData.length -
          rowsToShow,
          0
        );

      startIndex =
        Math.max(
          0,
          Math.min(
            startIndex,
            maximumStart
          )
        );

      return sizeData.slice(
        startIndex,
        startIndex +
        rowsToShow
      );
    }

    function updateTableRows(
      rows,
      selectedSize,
      unit
    ) {
      tableBody.innerHTML = '';

      rows.forEach(
        function (rowData) {
          const row =
            document.createElement(
              'tr'
            );

          if (
            sizeKey(
              rowData.size
            ) ===
            selectedSize
          ) {
            row.classList.add(
              'is-selected'
            );
          }

          const sizeCell =
            document.createElement(
              'td'
            );

          sizeCell.textContent =
            displaySizeLabel(
              rowData.size
            );

          row.appendChild(
            sizeCell
          );

          activeConfig.columns.forEach(
            function (column) {
              const cell =
                document.createElement(
                  'td'
                );

              cell.textContent =
                formatColumnValue(
                  rowData,
                  column,
                  unit
                );

              row.appendChild(
                cell
              );
            }
          );

          tableBody.appendChild(
            row
          );
        }
      );
    }

    function updateCustomMode(
      customSelected
    ) {
      var selectedKey = '';

      try {
        selectedKey =
          getSelectedSize(
            findSizeGroup()
          ) || '';
      } catch (error) {
        selectedKey = '';
      }

      chart.setAttribute(
        'data-size-state',
        customSelected
          ? 'custom'
          : (
            selectedKey
              ? 'standard'
              : 'none'
          )
      );

      standardChart.hidden =
        customSelected;

      customMeasurements.hidden =
        !customSelected;

      getCustomInputs().forEach(
        function (input) {
          input.disabled =
            !customSelected;

          input.required =
            customSelected;
        }
      );

      if (
        unitProperty
      ) {
        unitProperty.disabled =
          !customSelected;
      }
    }

    function updateUnitDisplay(
      unit
    ) {
      const suffix =
        unit === 'cm'
          ? 'cm'
          : 'in';

      getUnitSuffixes().forEach(
        function (element) {
          element.textContent =
            suffix;
        }
      );

      if (
        unitProperty
      ) {
        unitProperty.value =
          unit === 'cm'
            ? 'CM'
            : 'INCH';
      }

      unitButtons.forEach(
        function (button) {
          const active =
            button.dataset
              .unitButton ===
            unit;

          button.classList.toggle(
            'is-active',
            active
          );

          button.setAttribute(
            'aria-pressed',
            active
              ? 'true'
              : 'false'
          );
        }
      );
    }

    function convertCustomValues(
      fromUnit,
      toUnit
    ) {
      if (
        fromUnit ===
        toUnit
      ) {
        return;
      }

      getCustomInputs().forEach(
        function (input) {
          if (!input.value) {
            return;
          }

          const currentValue =
            Number(
              input.value
            );

          if (
            !Number.isFinite(
              currentValue
            )
          ) {
            return;
          }

          let convertedValue;

          if (
            fromUnit ===
              'inch' &&
            toUnit ===
              'cm'
          ) {
            convertedValue =
              Math.round(
                currentValue *
                2.54 *
                10
              ) / 10;
          } else {
            convertedValue =
              Math.round(
                (
                  currentValue /
                  2.54
                ) *
                100
              ) / 100;
          }

          input.value =
            convertedValue;
        }
      );
    }

    function renderChart() {
      const sizeGroup =
        ensureCorrectPosition();

      if (!sizeGroup) {
        return;
      }

      const selectedSize =
        getSelectedSize(
          sizeGroup
        );

      const unit =
        chart.dataset
          .currentUnit ||
        'inch';

      const customSelected =
        isCustomSize(
          selectedSize
        );

      const renderKey = [
        selectedSize,
        unit,
        customSelected
          ? 'custom'
          : 'standard'
      ].join('|');

      if (
        renderKey ===
        lastRenderKey
      ) {
        return;
      }

      lastRenderKey =
        renderKey;

      updateUnitDisplay(
        unit
      );

      updateCustomMode(
        customSelected
      );

      if (
        customSelected
      ) {
        return;
      }

      const selectedIndex =
        sizeData.findIndex(
          function (row) {
            return (
              sizeKey(
                row.size
              ) ===
              selectedSize
            );
          }
        );

      updateTableRows(
        getVisibleRows(
          selectedIndex
        ),
        selectedSize,
        unit
      );
    }

    function queueRender() {
      if (
        renderFrame
      ) {
        window.cancelAnimationFrame(
          renderFrame
        );
      }

      renderFrame =
        window.requestAnimationFrame(
          function () {
            renderFrame =
              window.requestAnimationFrame(
                function () {
                  renderFrame =
                    null;

                  renderChart();
                }
              );
          }
        );
    }

    function preparePropertiesForSubmit(
      productForm
    ) {
      const sizeGroup =
        findSizeGroup();

      if (
        !sizeGroup ||
        !productForm
      ) {
        return;
      }

      const selectedSize =
        getSelectedSize(
          sizeGroup
        );

      const customSelected =
        isCustomSize(
          selectedSize
        );

      updateCustomMode(
        customSelected
      );

      updateUnitDisplay(
        chart.dataset
          .currentUnit ||
        'inch'
      );

      connectPropertiesToForm(
        sizeGroup,
        productForm
      );
    }

    buildTableHeader();
    buildCustomFields();

    unitButtons.forEach(
      function (button) {
        button.addEventListener(
          'click',
          function () {
            const oldUnit =
              chart.dataset
                .currentUnit ||
              'inch';

            const newUnit =
              button.dataset
                .unitButton ||
              'inch';

            convertCustomValues(
              oldUnit,
              newUnit
            );

            chart.dataset
              .currentUnit =
              newUnit;

            lastRenderKey = '';

            queueRender();
          },
          {
            signal: signal
          }
        );
      }
    );

    document.addEventListener(
      'change',
      function (event) {
        if (
          chart.contains(
            event.target
          )
        ) {
          return;
        }

        const sizeGroup =
          findSizeGroup();

        if (
          sizeGroup &&
          sizeGroup.contains(
            event.target
          )
        ) {
          lastRenderKey = '';
          queueRender();
        }
      },
      {
        signal: signal
      }
    );

    document.addEventListener(
      'click',
      function (event) {
        if (
          chart.contains(
            event.target
          )
        ) {
          return;
        }

        const sizeGroup =
          findSizeGroup();

        if (
          sizeGroup &&
          sizeGroup.contains(
            event.target
          )
        ) {
          lastRenderKey = '';
          queueRender();
        }
      },
      {
        signal: signal
      }
    );

    document.addEventListener(
      'variant:change',
      function () {
        lastRenderKey = '';
        queueRender();
      },
      {
        signal: signal
      }
    );

    document.addEventListener(
      'product:variant-change',
      function () {
        lastRenderKey = '';
        queueRender();
      },
      {
        signal: signal
      }
    );

    document.addEventListener(
      'shopify:section:load',
      function () {
        lastRenderKey = '';
        queueRender();
      },
      {
        signal: signal
      }
    );

    document.addEventListener(
      'click',
      function (event) {
        if (
          !(
            event.target
            instanceof Element
          )
        ) {
          return;
        }

        const submitter =
          event.target.closest(
            'button[name="add"],' +
            'button[type="submit"],' +
            'input[type="submit"],' +
            '[data-add-to-cart]'
          );

        if (
          !submitter
        ) {
          return;
        }

        const productForm =
          submitter.form ||
          submitter.closest(
            'form[action*="/cart/add"]'
          );

        if (
          !productForm ||
          !productForm.matches(
            'form[action*="/cart/add"]'
          )
        ) {
          return;
        }

        preparePropertiesForSubmit(
          productForm
        );
      },
      {
        capture: true,
        signal: signal
      }
    );

    document.addEventListener(
      'submit',
      function (event) {
        const productForm =
          event.target;

        if (
          !(
            productForm
            instanceof
            HTMLFormElement
          ) ||
          !productForm.matches(
            'form[action*="/cart/add"]'
          )
        ) {
          return;
        }

        preparePropertiesForSubmit(
          productForm
        );
      },
      {
        capture: true,
        signal: signal
      }
    );

    pageObserver =
      new MutationObserver(
        function (mutations) {
          const relevant =
            mutations.some(
              function (
                mutation
              ) {
                return (
                  !chart.contains(
                    mutation.target
                  ) &&
                  (
                    mutation.addedNodes
                      .length > 0 ||
                    mutation.removedNodes
                      .length > 0
                  )
                );
              }
            );

          if (!relevant) {
            return;
          }

          window.clearTimeout(
            observerTimer
          );

          observerTimer =
            window.setTimeout(
              function () {
                lastRenderKey = '';
                queueRender();
              },
              120
            );
        }
      );

    const productScope =
      chart.closest(
        '.product__section'
      ) ||
      chart.closest(
        'product-info'
      ) ||
      chart.closest(
        'main'
      ) ||
      document.body;

    pageObserver.observe(
      productScope,
      {
        childList: true,
        subtree: true
      }
    );

    if (
      eventDate &&
      !eventDate.min
    ) {
      const today =
        new Date();

      const year =
        today.getFullYear();

      const month =
        String(
          today.getMonth() +
          1
        ).padStart(
          2,
          '0'
        );

      const day =
        String(
          today.getDate()
        ).padStart(
          2,
          '0'
        );

      eventDate.min =
        year +
        '-' +
        month +
        '-' +
        day;
    }

    let locateAttempts = 0;

    function locateAndStart() {
      locateAttempts += 1;

      const sizeGroup =
        ensureCorrectPosition();

      if (
        sizeGroup
      ) {
        lastRenderKey = '';
        queueRender();
        return;
      }

      if (
        locateAttempts <
        40
      ) {
        locateTimer =
          window.setTimeout(
            locateAndStart,
            150
          );
      }
    }

    updateUnitDisplay(
      'inch'
    );

    locateAndStart();
  }

  waitForData();

  }

  function mountAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('.jovellee-size-chart[data-size-chart-context="quickview"]').forEach(mount);
  }

  function cleanupChart(chart) {
    if (!chart || !chart.id) return;
    var cleanup = window.__jovelleeSizeChartCleanup && window.__jovelleeSizeChartCleanup[chart.id];
    if (typeof cleanup === 'function') cleanup();
    delete chart.dataset.chartMounted;
  }

  function observe() {
    if (!document.body || observe.started) return;
    observe.started = true;

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        Array.prototype.forEach.call(mutation.addedNodes, function (node) {
          if (!node || node.nodeType !== 1) return;
          if (node.matches && node.matches('.jovellee-size-chart[data-size-chart-context="quickview"]')) {
            mount(node);
          }
          if (node.querySelectorAll) {
            mountAll(node);
          }
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  function unmountAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('.jovellee-size-chart[data-size-chart-context="quickview"]').forEach(cleanupChart);
  }

  window.JovelleeSizeChart = {
    mount: mount,
    mountAll: mountAll,
    unmountAll: unmountAll
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      mountAll(document);
      observe();
    });
  } else {
    mountAll(document);
    observe();
  }
})();
